import { Injectable } from '@angular/core';

enum LocalStorageKeys {
    SidebarMainNavigationExpandedEntryKeys = 'sidebar_main_navigation_expanded_entry_keys',
    PreferredPageSize = 'preferred_page_size',
    SmartAssistantColumnMapping = 'smart_assistant_column_mapping'
}

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    static getSidebarMainNavigationExpandedEntryKeys(): string[] {
        const value = localStorage.getItem(LocalStorageKeys.SidebarMainNavigationExpandedEntryKeys);

        if (!value) {
            return null;
        }

        const parsedObject = JSON.parse(value);
        if (!Array.isArray(parsedObject)) {
            return null;
        }

        return parsedObject;
    }

    static setSidebarMainNavigationExpandedEntryKeys(expandedEntryKeys: string[]): void {
        localStorage.setItem(LocalStorageKeys.SidebarMainNavigationExpandedEntryKeys, JSON.stringify(expandedEntryKeys));
    }

    static getPreferredPageSize(): number | undefined {
        const value = localStorage.getItem(LocalStorageKeys.PreferredPageSize);

        if (!value) {
            return undefined;
        }

        const parsedValue = Number(value);
        if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
            return undefined;
        }

        return parsedValue;
    }

    static setPreferredPageSize(pageSize: number): void {
        localStorage.setItem(LocalStorageKeys.PreferredPageSize, JSON.stringify(pageSize));
    }

    static getSmartAssistantColumnMapping(): { [columnKey: string]: string } {
        const value = localStorage.getItem(LocalStorageKeys.SmartAssistantColumnMapping);

        if (!value) {
            return {};
        }

        let parsedObject: unknown;
        try {
            parsedObject = JSON.parse(value);
        } catch {
            return {};
        }

        if (typeof parsedObject !== 'object' || parsedObject === null || Array.isArray(parsedObject)) {
            return {};
        }

        const mapping: { [columnKey: string]: string } = {};
        for (const [key, header] of Object.entries(parsedObject)) {
            if (typeof header === 'string' && header !== '') {
                mapping[key] = header;
            }
        }
        return mapping;
    }

    static setSmartAssistantColumnMapping(mapping: { [columnKey: string]: string }): void {
        localStorage.setItem(LocalStorageKeys.SmartAssistantColumnMapping, JSON.stringify(mapping));
    }

    static removeSmartAssistantColumnMapping(): void {
        localStorage.removeItem(LocalStorageKeys.SmartAssistantColumnMapping);
    }
}
